/* DIVAZ: keep language and country consistent in the localization selectors.
   Picking a language whose home countries do not include the current country also switches the country
   (e.g. Magyar while in Austria -> Hungary, HUF). English and languages already valid for the country keep the country. */
(function () {
  var HOME = {
    bg: ['BG'], cs: ['CZ'], da: ['DK'], de: ['DE', 'AT', 'LU', 'BE'], el: ['GR'], es: ['ES'], et: ['EE'], fi: ['FI'],
    fr: ['FR', 'BE', 'LU'], hr: ['HR'], hu: ['HU'], it: ['IT'], lt: ['LT'], nl: ['NL', 'BE'], pl: ['PL'], 'pt-PT': ['PT'],
    sk: ['SK'], sl: ['SI'], sv: ['SE', 'FI'], ro: ['RO']
  };
  var current = (window.Shopify && Shopify.country) || '';

  function targetCountry(lang, country, available) {
    var homes = HOME[lang];
    if (!homes || homes.indexOf(country) !== -1) return null;
    for (var i = 0; i < homes.length; i++) {
      if (!available || available.indexOf(homes[i]) !== -1) return homes[i];
    }
    return null;
  }

  function availableCountries() {
    var list = [];
    document.querySelectorAll('[data-disclosure-currency] [data-disclosure-option], #country-code-select option').forEach(function (el) {
      var v = el.getAttribute('data-value') || el.value;
      if (v && list.indexOf(v) === -1) list.push(v);
    });
    return list.length ? list : null;
  }

  // Desktop/footer disclosure: runs in the capture phase, before the theme's option click handler submits the form.
  document.addEventListener('click', function (evt) {
    var option = evt.target.closest && evt.target.closest('[data-disclosure-locale] [data-disclosure-option]');
    if (!option) return;
    var form = option.closest('form');
    if (!form) return;
    var input = form.querySelector('input[name="country_code"]');
    var country = input ? input.value : current;
    var target = targetCountry(option.getAttribute('data-value'), country, availableCountries());
    if (!target) return;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      form.appendChild(input);
    }
    input.value = target;
  }, true);

  // Mobile regional settings form: language changed but country left as it was.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    var lang = form.querySelector && form.querySelector('select[name="language_code"]');
    var countrySel = form.querySelector && form.querySelector('select[name="country_code"]');
    if (!lang || !countrySel) return;
    if (lang.value === lang.getAttribute('data-original-value')) return;
    if (countrySel.value !== countrySel.getAttribute('data-original-value')) return;
    var target = targetCountry(lang.value, countrySel.value, availableCountries());
    if (target) countrySel.value = target;
  }, true);
})();
